import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable import/order */
/*
Wraps FormBuilder with keyboard shortcuts;
FormBuilder and FormPage accept the prop useKeyBoardShortcuts to enable shortcuts. Uses sorted list of fieldIds in sections to traverse through the fields.
Will not work with components that either dont render an input field in DOM or if the input field is not visible. Ex: Ant-select will not work, replace with react-select before enabling for your form.
Use handleKeyBoardOnChange boolean property in renderOptions of field to control traversal to next field on value change. Ex: DatePickers, Modal, Uploads
dispatches a FormEvent with type ON_FOCUS:fieldId  and param index when focus comes to a field for other components to capture;
listens to FormEvent with type FOCUS_PREV and FOCUS_NEXT with param index. Use this to focus on previous or next fields in form from other components.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// lodash
import _forEach from 'lodash/forEach';
import _get from 'lodash/get';
import _findIndex from 'lodash/findIndex';
import _isEqual from 'lodash/isEqual';
import _first from 'lodash/first';
import _last from 'lodash/last';

// constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import EVENT_TYPES from '../../../pages/formPage/constants/eventTypes';

// utils
import FormEvent from '@tekion/tekion-base/utils/formEvent';
import sleep from '@tekion/tekion-base/utils/sleep';

// helpers
import { getUpdatedFields, findParent, getIndexByClassName } from '../../../helpers/keyboardHelper';
var withShortcutKeys = function withShortcutKeys(WrappedComponent) {
  var WithShortcutKeys = /*#__PURE__*/function (_Component) {
    _inherits(WithShortcutKeys, _Component);
    var _super = _createSuper(WithShortcutKeys);
    function WithShortcutKeys(props) {
      var _this;
      _classCallCheck(this, WithShortcutKeys);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "mouseHandler", function (e) {
        var element = e.target;
        var index = _this.getIndex(element);
        _this.setState({
          currentIndex: index
        });
      });
      _defineProperty(_assertThisInitialized(_this), "getIndex", function (element) {
        var classList = _this.state.classList;
        var cell = findParent(element, 'formFocusable');
        if (cell) {
          return getIndexByClassName(classList, cell.className);
        }
        return -1;
      });
      _defineProperty(_assertThisInitialized(_this), "keyBoardHandler", function (e) {
        var _this$state = _this.state,
          currentIndex = _this$state.currentIndex,
          skipList = _this$state.skipList,
          classList = _this$state.classList;
        var currentItemID = classList[currentIndex];
        if (!currentItemID || skipList.includes(currentItemID) && e.keyCode === 13) {
          return;
        }
        if (e.shiftKey && e.code === 'Tab') {
          _this.goToPrevField(currentIndex);
        } else {
          switch (e.code) {
            case 'Tab':
            case 'ArrowRight':
            case 'NumpadEnter':
            case 'Enter':
              _this.goToNextField(currentIndex, e.code);
              break;
            case 'ArrowLeft':
              // Prev arrow
              _this.goToPrevField(currentIndex);
              break;
            default:
              break;
          }
        }
      });
      _defineProperty(_assertThisInitialized(_this), "handleGoToNextFieldWithNoErrorRestrictions", function (currentIndex, keycode) {
        var classList = _this.state.classList;
        if (currentIndex >= 0 && currentIndex < classList.length) {
          var nextIndex = currentIndex + 1;
          _this.focusElement(nextIndex, true, keycode);
        }
      });
      _defineProperty(_assertThisInitialized(_this), "checkIfFieldHasErrors", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(currentIndex) {
          var classList, errors, hasError;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                classList = _this.state.classList;
                _context.next = 3;
                return sleep(5);
              case 3:
                // it takes few ms to update the error props;
                errors = _this.props.errors;
                hasError = errors[classList[currentIndex]];
                return _context.abrupt("return", hasError);
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      _defineProperty(_assertThisInitialized(_this), "handleGoToNextFieldWithErrorRestrictions", /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(currentIndex, keycode) {
          var classList, hasError, nextIndex;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                classList = _this.state.classList;
                _this.showFieldErrors(currentIndex);
                _context2.next = 4;
                return _this.checkIfFieldHasErrors(currentIndex);
              case 4:
                hasError = _context2.sent;
                if (currentIndex >= 0 && currentIndex < classList.length && !hasError) {
                  nextIndex = currentIndex + 1;
                  _this.focusElement(nextIndex, true, keycode);
                }
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }());
      _defineProperty(_assertThisInitialized(_this), "handleGoToPrevFieldWithNoErrorRestrictions", function (currentIndex) {
        if (currentIndex >= 1) {
          var prevIndex = currentIndex - 1;
          _this.focusElement(prevIndex, false);
        }
      });
      _defineProperty(_assertThisInitialized(_this), "goToPrevFieldByClassName", function (className) {
        var classList = _this.state.classList;
        _this.isFocusFirstField = false;
        var index = getIndexByClassName(classList, className);
        _this.goToPrevField(index);
      });
      _defineProperty(_assertThisInitialized(_this), "goToNextFieldByClassName", function (className) {
        var classList = _this.state.classList;
        _this.isFocusFirstField = true;
        var index = getIndexByClassName(classList, className);
        _this.goToNextField(index);
      });
      _defineProperty(_assertThisInitialized(_this), "goToNextField", function (currentIndex, key) {
        var isKeyActionRestrictedOnError = _this.checkIfKeyActionIsRestrictedOnError(currentIndex, key);
        if (!isKeyActionRestrictedOnError) {
          return _this.handleGoToNextFieldWithNoErrorRestrictions(currentIndex, key);
        }
        return _this.handleGoToNextFieldWithErrorRestrictions(currentIndex, key);
      });
      _defineProperty(_assertThisInitialized(_this), "goToPrevField", function (currentIndex) {
        return _this.handleGoToPrevFieldWithNoErrorRestrictions(currentIndex);
      });
      _defineProperty(_assertThisInitialized(_this), "focusElement", function (index) {
        var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var keycode = arguments.length > 2 ? arguments[2] : undefined;
        var fields = _this.props.fields;
        var classList = _this.state.classList;
        var currentItem = fields[classList[index]] || EMPTY_OBJECT;
        var isDisabled = _get(currentItem, 'renderOptions.isDisabled') || _get(currentItem, 'renderOptions.disabled') || false;
        if (isDisabled) {
          return next ? _this.goToNextField(index, keycode) : _this.goToPrevField(index);
        }
        var searchClass = classList[index];
        var cell = searchClass && document.getElementsByClassName(searchClass)[0];
        if (cell) {
          var inputList = cell.querySelectorAll('input:not([disabled])');
          var input = _this.isFocusFirstField ? _last(inputList) : _first(inputList);
          if (input) {
            input.focus();
          }
        }
        var currentIndex = _this.getIndex(document.activeElement);
        _this.setState({
          currentIndex: currentIndex
        });
        return true;
      });
      var _getUpdatedFields = getUpdatedFields(props.fields, props.sections),
        _fields = _getUpdatedFields.fields,
        _skipList = _getUpdatedFields.skipList,
        _classList = _getUpdatedFields.classList;
      _this.formComponent = /*#__PURE__*/React.createRef();
      _this.isFocusFirstField = false;
      _this.state = {
        fields: _fields,
        skipList: _skipList,
        classList: _classList,
        currentIndex: 0
      };
      return _this;
    }
    _createClass(WithShortcutKeys, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.formComponent.current.addEventListener('keyup', this.keyBoardHandler);
        this.formComponent.current.addEventListener('mousedown', this.mouseHandler);
        FormEvent.on(EVENT_TYPES.FOCUS_NEXT, this.goToNextFieldByClassName);
        FormEvent.on(EVENT_TYPES.FOCUS_PREV, this.goToPrevFieldByClassName);
        this.focusElement(0);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;
        var _this$state2 = this.state,
          skipList = _this$state2.skipList,
          currentIndex = _this$state2.currentIndex;
        var prevValues = prevProps.values;
        var values = this.props.values;
        _forEach(skipList, function (field) {
          if (!_isEqual(prevValues[field], values[field])) {
            _this2.goToNextField(currentIndex);
          }
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.formComponent.current.removeEventListener('keyup', this.keyBoardHandler);
        this.formComponent.current.removeEventListener('mousedown', this.mouseHandler);
        FormEvent.removeListener(EVENT_TYPES.FOCUS_NEXT, this.goToNextFieldByClassName);
        FormEvent.removeListener(EVENT_TYPES.FOCUS_PREV, this.goToPrevFieldByClassName);
      }
    }, {
      key: "getKeysDisabledOnError",
      value: function getKeysDisabledOnError(index) {
        var fields = this.props.fields;
        var classList = this.state.classList;
        var currentItem = fields[classList[index]];
        var keysDisabledOnError = _get(currentItem, 'renderOptions.keysDisabledOnError', EMPTY_ARRAY);
        return keysDisabledOnError;
      }
    }, {
      key: "showFieldErrors",
      value:
      // eslint-disable-next-line react/sort-comp
      function showFieldErrors(index) {
        var classList = this.state.classList;
        var searchClass = classList[index];
        var cell = searchClass && document.getElementsByClassName(searchClass)[0];
        if (cell) {
          var input = cell.querySelector('input');
          if (input) {
            input.blur();
            input.focus();
          }
        }
      }
    }, {
      key: "checkIfKeyActionIsRestrictedOnError",
      value: function checkIfKeyActionIsRestrictedOnError(currentIndex, key) {
        var keysDisabledOnError = this.getKeysDisabledOnError(currentIndex);
        var keyIndex = _findIndex(keysDisabledOnError, _isEqual.bind(this, key));
        var isKeyActionRestrictedOnError = keyIndex !== -1;
        return isKeyActionRestrictedOnError;
      }
    }, {
      key: "render",
      value: function render() {
        var fields = this.state.fields;
        return /*#__PURE__*/React.createElement("div", {
          ref: this.formComponent
        }, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
          fields: fields
        })));
      }
    }]);
    return WithShortcutKeys;
  }(Component);
  _defineProperty(WithShortcutKeys, "getDerivedStateFromProps", function (props) {
    var _getUpdatedFields2 = getUpdatedFields(props.fields, props.sections),
      fields = _getUpdatedFields2.fields,
      skipList = _getUpdatedFields2.skipList,
      classList = _getUpdatedFields2.classList;
    return {
      fields: fields,
      skipList: skipList,
      classList: classList
    };
  });
  WithShortcutKeys.propTypes = {
    fields: PropTypes.object,
    rows: PropTypes.array,
    sections: PropTypes.array,
    values: PropTypes.object,
    errors: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
  };
  WithShortcutKeys.defaultProps = {
    fields: EMPTY_OBJECT,
    rows: EMPTY_ARRAY,
    sections: EMPTY_ARRAY,
    values: EMPTY_OBJECT,
    errors: undefined
  };
  return WithShortcutKeys;
};
export default withShortcutKeys;